import _ from 'lodash';
import store from '../redux';

class Utils { }

Utils.MONDAY    = "mo";
Utils.TUESDAY   = "tu";
Utils.WEDNESDAY = "we";
Utils.THURSDAY  = "th";
Utils.FRIDAY    = "fr";
Utils.SATURDAY  = "sa";
Utils.SUNDAY    = "su";

Utils.DURATION_5_MIN     = 'PT5M';
Utils.DURATION_10_MIN    = 'PT10M';
Utils.DURATION_15_MIN    = 'PT15M';
Utils.DURATION_30_MIN    = 'PT30M';
Utils.DURATION_45_MIN    = 'PT45M';
Utils.DURATION_1_HOUR    = 'PT1H';
Utils.DURATION_6_HOURS   = 'PT6H';
Utils.DURATION_12_HOURS  = 'PT12H';
Utils.DURATION_1_DAY     = 'P1D';
Utils.DURATION_7_DAYS    = 'P7D';
Utils.DURATION_1_MONTH   = 'P1M';
Utils.DURATION_6_MONTHS  = 'P6M';
Utils.DURATION_1_YEAR    = 'P1Y';
Utils.DURATION_18_MONTHS = 'P1Y6M';

Utils.DEFAULT_LANGS = ['fr', 'en'];
Utils.LOCALES       = ['fr_CH', 'en_GB'];

Utils.roles = (role = null, no_super_admin) => {
    let roles = [
        { "role": "admin", "label": "Administrateur" },
        { "role": "teacher", "label": "Professeur" },
        { "role": "user", "label": "Utilisateur" }
    ];

    !no_super_admin &&
        roles.unshift({ "role": "super_admin", "label": "Super administrateur" });

    return role ? roles.find((r) => r.role === role) : roles;
};

Utils.days = (index) => {
    const days = [
        { "index": 1, "label": Utils.MONDAY },
        { "index": 2, "label": Utils.TUESDAY },
        { "index": 3, "label": Utils.WEDNESDAY },
        { "index": 4, "label": Utils.THURSDAY },
        { "index": 5, "label": Utils.FRIDAY },
        { "index": 6, "label": Utils.SATURDAY },
        { "index": 0, "label": Utils.SUNDAY }
    ];

    return index >= 0 ? days.find((d) => d.index === index) : days;
};

Utils.durations = () => {
    return [
        Utils.DURATION_5_MIN,
        Utils.DURATION_10_MIN,
        Utils.DURATION_15_MIN,
        Utils.DURATION_30_MIN,
        Utils.DURATION_45_MIN,
        Utils.DURATION_1_HOUR,
        Utils.DURATION_6_HOURS,
        Utils.DURATION_12_HOURS,
        Utils.DURATION_1_DAY,
        Utils.DURATION_7_DAYS,
        Utils.DURATION_1_MONTH,
        Utils.DURATION_6_MONTHS,
        Utils.DURATION_1_YEAR,
        Utils.DURATION_18_MONTHS,
    ];
};

Utils.dotify = (obj) => {
    var res = {};
    function recurse(obj, current) {
        for (var key in obj) {
            var value = obj[key];
            var newKey = (current ? current + '.' + key : key);  // joined key with dot
            if (value && typeof value === 'object') {
                recurse(value, newKey);  // it's a nested object, so do it again
            } else {
                res[newKey] = value;  // it's not an object, so set the property
            }
        }
    }

    recurse(obj);
    return res;
};

Utils.getDotified = (obj, dotifiedNotation) => {
    if (!obj)
        return null;

    return dotifiedNotation.split('.').reduce((a, b) => a ? a[b] : null, obj);
}

Utils.assignDotified = (obj, prop, value) => {
    if (typeof prop === "string")
        prop = prop.split(".");

    if (prop.length > 1) {
        var e = prop.shift();
        Utils.assignDotified(
            obj[e] = Object.prototype.toString.call(obj[e]) === "[object Object]" ? obj[e] : {},
            prop,
            value
        );
    } else {
        obj[prop[0]] = value;
    }
}

Utils.normalizeBoolean = (value) => {
    if (value === "true") {
        return true;
    }

    if (value === "false") {
        return false;
    }

    return value;
};

Utils.normalizeInt = (value) => {
    return parseInt(value, 10);
};

Utils.ucfirst = (string) => {
    if (!_.isString(string) || string.length === 0)
        return ""; 

    if (string.length === 1)
        return string.charAt(0).toUpperCase();

    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

Utils.langs = () => {
    return Utils.DEFAULT_LANGS.map((lang) => {
        return lang.split("_")[0]
    })
}

Utils.locales = () => {
    return Utils.LOCALES;
}

Utils.default_lang = () => {
    if (Utils.langs().length) {
        return Utils.langs()[0];
    }

    return 'fr';
}

Utils.currency = () => store.getState().settings.setting?.l10n?.currency || 'EUR';

Utils.localized_or_fallback = (obj, lang) => {
    if (obj[lang]) {
        return obj[lang];
    }

    const fallback = [...Utils.langs(), ...Object.keys(obj)].map(lang => {
        if (obj[lang]) {
            return `${obj[lang]}`;
        }
        return null;
    }).filter(Boolean);

    return fallback ? fallback[0] : null;
}

Utils.default_translatable_fields = () => {
    const fields = {};

    Utils.langs().map(lang => fields[lang] = '');

    return fields;
}

Utils.sortAndIndentCats = (cats, idField = '_id', parentField = 'parent') => {
    const _cats = _.cloneDeep(cats);
    let map = {};
    _cats.forEach((c) => {
        c.children = [];
        map[c[idField]] = c;
    });
    _cats.forEach((c) => {
        if (c[parentField]) {
            if (map[c[parentField]])
                map[c[parentField]].children.push(c);
            else
                c[parentField] = null;
        }
    });
    Object.keys(map).forEach((id) => { map[id][parentField] && delete map[id]; });

    let enhanced = [];
    const _indent_and_sort = (root, level) => {
        const default_lang = Utils.default_lang();
        const cats = _.sortBy(root, (c) => c.name[default_lang]);
        cats.forEach((c) => {
            Utils.langs().forEach((lang) => {
                for (let i = 0; i < level; i++) {
                    c.name[lang] && (c.name[lang] = ' - ' + c.name[lang]);
                }
            });
            enhanced.push(c);
            _indent_and_sort(c.children, level + 1);
        });
    };
    _indent_and_sort(_.values(map), 0);

    return _.map(enhanced, (c) => {
        delete c.children;
        return c;
    });
};

Utils.cleanTranslatableProperty = (object, property) => {
    if (!(property in object))
        return object;

    if (!_.isObject(object[property]))
        return object;

    _.mapKeys(object[property], (value, lang) => {
        if (_.isEmpty(object[property][lang]))
            delete object[property][lang];
    });

    return object;
}

Utils.trimProperties = (data) => {
    if (_.isString(data)) {
        return _.trim(data);
    };

    if (_.isObject(data)) {
        if (_.isNull(data) || _.isFunction(data)) {
            return data;
        };

        if (_.isArray(data)) {
            return data.map(e => {
                return Utils.trimProperties(e);
            });
        };

        Object.keys(data).forEach(key => {
            data[key] = Utils.trimProperties(data[key]);
        });
    };

    return data;
};

Utils.sortOnProperty = (property) => (a, b) => {
    a = a[property] ?? a; 
    b = b[property] ?? b; 

    // force null and undefined to the bottom
    a = a === null || a === undefined ? '' : a
    b = b === null || b === undefined ? '' : b
    // force any string values to lowercase
    a = typeof a === 'string' ? a.toLowerCase() : a
    b = typeof b === 'string' ? b.toLowerCase() : b
    // Return either 1 or -1 to indicate a sort priority
    if (a > b || (a === 0 && b === "")) {
        return 1
    }
    if (a < b || (b === 0 && a === "")) {
        return -1 
    }
    // returning 0, undefined or any falsey value will use subsequent sorts or
    // the index as a tiebreaker
    return 0
}

export default Utils;
